// services/contactService.js
import axiosInstance from "./axiosInstance";

//Gửi yêu cầu liên hệ mới từ khách hàng
export const createContact = (data) => {
    return axiosInstance.post("/contacts", data);
};

// 📋 Lấy danh sách liên hệ khách hàng
export const contactService = {
    getAll: (params) => axiosInstance.get("/contacts", { params }), // hỗ trợ filter + phân trang
    updateStatus: (id, status) =>
        axiosInstance.patch(`/contacts/${id}/status`, { status }),
};
